import gql from "graphql-tag";

export default gql`
  query AdminGenerateSubscriptionDefaultRefundOptions($subscriptionId: Int!) {
    admin_generateSubscriptionDefaultRefundOptions(
      subscriptionId: $subscriptionId
    ) {
      refunder
      feeRetentionMethod
      stripeFeePayer
    }
  }
`;
